const saveAuthToken = (token) => {
  if (typeof token !== "string") {
    const existingToken = sessionStorage.getItem("token");
    if (existingToken === "undefined" || existingToken === "null") {
      sessionStorage.removeItem("token");
    }
    return false;
  }

  const normalizedToken = token.trim();
  if (
    !normalizedToken ||
    normalizedToken === "undefined" ||
    normalizedToken === "null"
  ) {
    const existingToken = sessionStorage.getItem("token");
    if (existingToken === "undefined" || existingToken === "null") {
      sessionStorage.removeItem("token");
    }
    return false;
  }

  sessionStorage.setItem("token", normalizedToken);
  window.dispatchEvent(new Event("rankplus-auth-state-change"));
  return true;
};

export default saveAuthToken;